<template>
  <div>
    <el-card class="box-card">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-form-item label="登录账号" prop="mobile">
            <el-input v-model="ruleForm.mobile" :readonly="readonly"></el-input>
          </el-form-item>
          <el-form-item label="原始密码" prop="oldpwd">
            <el-input type="password" v-model="ruleForm.oldpwd" autocomplete="off" placeholder="忘记原始密码请重置后输入"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newpwd">
            <el-input type="password" v-model="ruleForm.newpwd" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPwd">
            <el-input type="password" v-model="ruleForm.checkPwd" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">确认修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { updatePwdApi } from '@/api/getData.js'
import { getCurrentUsernameApi } from '@/api/getData.js'
import md5 from 'js-md5'
import { encrypt } from '@/utils/jsencrypt.js'
export default {
  data() {
    // var validatePass = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入密码'))
    //   } else {
    //     if (this.ruleForm.checkPwd !== '') {
    //       this.$refs.ruleForm.validateField('checkPwd')
    //     }
    //     callback()
    //   }
    // }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        //以下密码复杂性校验正式环境再开放
        var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,16}/
        if (!passwordreg.test(value)) {
          callback(new Error('密码必须由数字、字母、特殊字符组合,请输入6-16位'))
        }
        if (this.ruleForm.checkPwd !== '') {
          this.$refs.ruleForm.validateField('checkPwd')
          callback()
        }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.newpwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        mobile: '',
        oldpwd: '',
        newpwd: '',
        checkPwd: ''
      },
      rules: {
        newpwd: [{ required: true, validator: validatePass, trigger: 'blur' }],
        checkPwd: [{ required: true, validator: validatePass2, trigger: 'blur' }]
      },
      loading: false,
      readonly: true
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          //调用修改密码接口
          var salt = this.ruleForm.mobile.substring(2, 6)
          this.ruleForm.oldpwd = encrypt(md5(salt + this.ruleForm.oldpwd + salt).toUpperCase()) //RSA加密（嵌套MD5加密）
          this.ruleForm.newpwd = encrypt(md5(salt + this.ruleForm.newpwd + salt).toUpperCase())
          this.ruleForm.checkPwd = encrypt(md5(salt + this.ruleForm.checkPwd + salt).toUpperCase())
          updatePwdApi(this.ruleForm).then(res => {
            if (res.data.code === 0) {
              alert('修改成功!')
              //this.toLogin()
              this.ruleForm.oldpwd = ''
              this.ruleForm.newpwd = ''
              this.ruleForm.checkPwd = ''
            } else {
              alert('修改失败!' + res.data.msg)
              this.ruleForm.oldpwd = ''
              this.ruleForm.newpwd = ''
              this.ruleForm.checkPwd = ''
            }
            this.loading = false
          })
        } else {
          this.$message({
            type: 'warning',
            message: '填写信息有误，请检查!'
          })
          return false
        }
      })
    },
    getCurrentUsername() {
      getCurrentUsernameApi().then(res => {
        res = res.data
        console.info(res.data)
        this.ruleForm.mobile = res.data
      })
    }
  },
  mounted() {
    //this.identifyCode = ''
    this.getCurrentUsername()
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  width: 500px;
  margin: auto;
  padding: 45px;
  height: 400px;
  background-color: #fff;

  //margin-left: 1000px;
  float: left;
  //margin-top: 50px;
  border-radius: 15px;
  // background-image: url('../../assets/images/background.jpg');
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  // -moz-background-size: 100% 100%;
}

.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 50px;
  padding: 10px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
h5 {
  font-size: max($numbers: 25px);
}
.index_background {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/images/background1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

.box-card {
  height: 100%;
  width: 90%;
}
</style>
